export const projectTypes = [
    { code: 'conference', noPrefix: 'YHY', label: '医会议-会议项目' },
    { code: 'selection', noPrefix: 'YPX', label: '医评议-评议项目' },
    { code: 'invitation', noPrefix: 'YYQ', label: '医邀请-邀请组' },
    { code: 'survey', noPrefix: 'YDY', label: '医调研-调研问卷' },
];

// 医项目状态：
// 1已上架
// 2已下架
export const projectStatusList = [
    { status: 1, label: '已上架', type: 'success' },
    { status: 2, label: '已下架', type: 'warning' },
];

export const contentTypes = [
    { type: 'article', label: '文章' }, // 平台
    { type: 'article_wm', label: '文章' }, // 用户
    { type: 'case', label: '实践' },
    { type: 'live', label: '直播' },
    { type: 'course', label: '课程' },
    { type: 'solution', label: '解决方案' },
    { type: 'conference_live', label: '直播' },
];
